<i18n>
{
"en": {
  "NOTFOUND": "Not Found",
  "LOST": "Looks like you've got lost...",
  "NOTEXIST": "The page you're looking for doesn't exist or has been moved.",
  "GOHOME": "Go Home"
},
"ar": {
  "NOTFOUND": "غير معثور عليه",
  "LOST": "يبدو أنك قد ضاعت...",
  "NOTEXIST": "الصفحة التي تبحث عنها غير موجودة أو تم نقلها.",
  "GOHOME": "اذهب للمنزل"
}
}
</i18n>
<template>
    <el-card  class="card-border" ref="card" id="report" :body-style="{ padding: 0 }" :style="{ height: cardHeight + 'px' }">
        <el-row :gutter="20" style="padding: 20px;">
            <el-col :span="24">
                <div class="page-404">
                    <i class="fa fa-exclamation-triangle fa-5x"></i>
                    <h1>{{$t('NOTFOUND')}}</h1>
                    <h3>{{$t('LOST')}}</h3>
                    <p>{{$t('NOTEXIST')}}</p>
                    <p><el-button @click="$router.push('/')">{{$t('GOHOME')}}</el-button></p>
                    
                </div>
            </el-col>
        </el-row>
    </el-card>
</template>
<script>
export default {
  data () {
    return {
      cardHeight: 0
    }
  },
  mounted () {
    this.switchLanguage()
    this.$nextTick(function () {
      this.cardHeight = window.innerHeight - this.$el.offsetHeight - 53
    })
  }
}
</script>

<style>
.page-404{
    text-align: center;
    padding: 120px 0px;
    background-color: #fff;
}
.page-404 h1{
    font-size: 200px;
        margin: 50px;
}
.page-404 h3{
    font-size: 35px;
    margin-bottom: 20px;
}
.page-404 p{
    font-size: 20px;
}
.page-404 .el-button{
    margin-top: 20px;
    text-transform: uppercase;
    font-weight: 600;
    padding: 15px 35px;
    background-color: #f4c135;
    border-color:#fff;
    color:#fff;
    border-radius: 30px;
}
.page-404 .el-button:hover{
    background: transparent;
    border-color: #f4c135;
    color:#f4c135;
}
.page-404 .svg-inline--fa{
    font-size: 100px;
}
</style>




// WEBPACK FOOTER //
// 404.vue?2673542c